/** Chakra style props for the dark-themed 2FA modal content. */
const twoFactorContentProps = {
    background: "rgba(30, 30, 30, 0.97)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "xl"
};

/** Chakra style props for the 2FA modal title. */
const twoFactorTitleProps = {
    color: "rgba(255, 255, 255, 0.95)",
    fontWeight: 600
};

/** Chakra style props for the 2FA code input. */
const twoFactorFieldProps = {
    color: "rgba(255, 255, 255, 0.95)",
    letterSpacing: "0.4rem",
    fontSize: "1.3rem",
    textAlign: "center",
    borderColor: "rgba(255, 255, 255, 0.2)",
    _hover: { borderColor: "rgba(255, 255, 255, 0.3)" },
    _focus: { borderColor: "#17dcb8", boxShadow: "none" }
};

/** Chakra style props for the cancel button. */
const twoFactorCancelButtonProps = {
    color: "rgba(255, 255, 255, 0.8)",
    background: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    _hover: { background: "rgba(255, 255, 255, 0.1)" }
};

/** Chakra style props for the confirm button. */
const twoFactorConfirmButtonProps = {
    background: "rgba(23, 220, 184, 0.15)",
    color: "#17dcb8",
    border: "1px solid rgba(23, 220, 184, 0.4)",
    fontWeight: 600,
    _hover: { background: "rgba(23, 220, 184, 0.25)" },
    _disabled: { opacity: 0.5 }
};

export {
    twoFactorContentProps,
    twoFactorTitleProps,
    twoFactorFieldProps,
    twoFactorCancelButtonProps,
    twoFactorConfirmButtonProps
};
